import { jsx as _jsx } from "react/jsx-runtime";
import Link from 'next/link';
import { forwardRef } from 'react';
import { styled } from '@zurich/ui/legacy/utils';
const LinkStyled = styled(Link)({
    textDecoration: 'none',
    color: 'inherit',
});
export const NextLink = forwardRef(function NextLink({ href, ...props }, ref) {
    if (!href) {
        throw new Error('NextLink was called without href property');
    }
    return _jsx(LinkStyled, { href: href, ref: ref, ...props });
});
